/*export const FETCH_EXECUTIVE_REQUESTS_REQUEST =
  "FETCH_EXECUTIVE_REQUESTS_REQUEST";
export const FETCH_EXECUTIVE_REQUESTS_SUCCESS =
  "FETCH_EXECUTIVE_REQUESTS_SUCCESS";
export const FETCH_EXECUTIVE_REQUESTS_FAILURE =
  "FETCH_EXECUTIVE_REQUESTS_FAILURE";
export const FETCH_EXECUTIVE_REQUEST_DETAILS_REQUEST =
  "FETCH_EXECUTIVE_REQUEST_DETAILS_REQUEST";
export const FETCH_EXECUTIVE_REQUEST_DETAILS_SUCCESS =
  "FETCH_EXECUTIVE_REQUEST_DETAILS_SUCCESS";
export const FETCH_EXECUTIVE_REQUEST_DETAILS_FAILURE =
  "FETCH_EXECUTIVE_REQUEST_DETAILS_FAILURE";
export const ADD_EXECUTIVE_REQUEST_REQUEST = "ADD_EXECUTIVE_REQUEST_REQUEST";
export const ADD_EXECUTIVE_REQUEST_SUCCESS = "ADD_EXECUTIVE_REQUEST_SUCCESS";
export const ADD_EXECUTIVE_REQUEST_FAILURE = "ADD_EXECUTIVE_REQUEST_FAILURE";
export const ADD_APPROVE_REQUEST_REQUEST = "ADD_APPROVE_REQUEST_REQUEST";
export const ADD_APPROVE_REQUEST_SUCCESS = "ADD_APPROVE_REQUEST_SUCCESS";
export const ADD_APPROVE_REQUEST_FAILURE = "ADD_APPROVE_REQUEST_FAILURE";
export const ADD_ATTEST_REQUEST_REQUEST = "ADD_ATTEST_REQUEST_REQUEST";
export const ADD_ATTEST_REQUEST_SUCCESS = "ADD_ATTEST_REQUEST_SUCCESS";
export const ADD_ATTEST_REQUEST_FAILURE = "ADD_ATTEST_REQUEST_FAILURE";
export const ADD_VERIFY_REQUEST_REQUEST = "ADD_VERIFY_REQUEST_REQUEST";
export const ADD_VERIFY_REQUEST_SUCCESS = "ADD_VERIFY_REQUEST_SUCCESS";
export const ADD_VERIFY_REQUEST_FAILURE = "ADD_VERIFY_REQUEST_FAILURE";
export const ADD_REJECT_REQUEST_REQUEST = "ADD_REJECT_REQUEST_REQUEST";
export const ADD_REJECT_REQUEST_SUCCESS = "ADD_REJECT_REQUEST_SUCCESS";
export const ADD_REJECT_REQUEST_FAILURE = "ADD_REJECT_REQUEST_FAILURE";
export const ADD_PAY_REQUEST_REQUEST = "ADD_PAY_REQUEST_REQUEST";
export const ADD_PAY_REQUEST_SUCCESS = "ADD_PAY_REQUEST_SUCCESS";
export const ADD_PAY_REQUEST_FAILURE = "ADD_PAY_REQUEST_FAILURE";
export const ADD_QUERY_REQUEST_REQUEST = "ADD_QUERY_REQUEST_REQUEST";
export const ADD_QUERY_REQUEST_SUCCESS = "ADD_QUERY_REQUEST_SUCCESS";
export const ADD_QUERY_REQUEST_FAILURE = "ADD_QUERY_REQUEST_FAILURE";
export const FETCH_EXECUTIVE_VOUCHERS_REQUEST =
  "FETCH_EXECUTIVE_VOUCHERS_REQUEST";
export const FETCH_EXECUTIVE_VOUCHERS_SUCCESS =
  "FETCH_EXECUTIVE_VOUCHERS_SUCCESS";
export const FETCH_EXECUTIVE_VOUCHERS_FAILURE =
  "FETCH_EXECUTIVE_VOUCHERS_FAILURE";
export const CLEAR_EXECUTIVE_REQUESTS_ERROR = "CLEAR_EXECUTIVE_REQUESTS_ERROR";
*/

export const FETCH_EXECUTIVE_REQUESTS_REQUEST =
  "FETCH_EXECUTIVE_REQUESTS_REQUEST";
export const FETCH_EXECUTIVE_REQUESTS_SUCCESS =
  "FETCH_EXECUTIVE_REQUESTS_SUCCESS";
export const FETCH_EXECUTIVE_REQUESTS_FAILURE =
  "FETCH_EXECUTIVE_REQUESTS_FAILURE";
export const FETCH_EXECUTIVE_REQUEST_DETAILS_REQUEST =
  "FETCH_EXECUTIVE_REQUEST_DETAILS_REQUEST";
export const FETCH_EXECUTIVE_REQUEST_DETAILS_SUCCESS =
  "FETCH_EXECUTIVE_REQUEST_DETAILS_SUCCESS";
export const FETCH_EXECUTIVE_REQUEST_DETAILS_FAILURE =
  "FETCH_EXECUTIVE_REQUEST_DETAILS_FAILURE";
export const ADD_EXECUTIVE_REQUEST_REQUEST = "ADD_EXECUTIVE_REQUEST_REQUEST";
export const ADD_EXECUTIVE_REQUEST_SUCCESS = "ADD_EXECUTIVE_REQUEST_SUCCESS";
export const ADD_EXECUTIVE_REQUEST_FAILURE = "ADD_EXECUTIVE_REQUEST_FAILURE";
export const UPDATE_EXECUTIVE_REQUEST_REQUEST =
  "UPDATE_EXECUTIVE_REQUEST_REQUEST";
export const UPDATE_EXECUTIVE_REQUEST_SUCCESS =
  "UPDATE_EXECUTIVE_REQUEST_SUCCESS";
export const UPDATE_EXECUTIVE_REQUEST_FAILURE =
  "UPDATE_EXECUTIVE_REQUEST_FAILURE";
export const SUBMIT_EXECUTIVE_REQUEST_REQUEST =
  "SUBMIT_EXECUTIVE_REQUEST_REQUEST";
export const SUBMIT_EXECUTIVE_REQUEST_SUCCESS =
  "SUBMIT_EXECUTIVE_REQUEST_SUCCESS";
export const SUBMIT_EXECUTIVE_REQUEST_FAILURE =
  "SUBMIT_EXECUTIVE_REQUEST_FAILURE";
export const ADD_APPROVE_REQUEST_REQUEST = "ADD_APPROVE_REQUEST_REQUEST";
export const ADD_APPROVE_REQUEST_SUCCESS = "ADD_APPROVE_REQUEST_SUCCESS";
export const ADD_APPROVE_REQUEST_FAILURE = "ADD_APPROVE_REQUEST_FAILURE";
export const ADD_ATTEST_REQUEST_REQUEST = "ADD_ATTEST_REQUEST_REQUEST";
export const ADD_ATTEST_REQUEST_SUCCESS = "ADD_ATTEST_REQUEST_SUCCESS";
export const ADD_ATTEST_REQUEST_FAILURE = "ADD_ATTEST_REQUEST_FAILURE";
export const ADD_VERIFY_REQUEST_REQUEST = "ADD_VERIFY_REQUEST_REQUEST";
export const ADD_VERIFY_REQUEST_SUCCESS = "ADD_VERIFY_REQUEST_SUCCESS";
export const ADD_VERIFY_REQUEST_FAILURE = "ADD_VERIFY_REQUEST_FAILURE";
export const ADD_REJECT_REQUEST_REQUEST = "ADD_REJECT_REQUEST_REQUEST";
export const ADD_REJECT_REQUEST_SUCCESS = "ADD_REJECT_REQUEST_SUCCESS";
export const ADD_REJECT_REQUEST_FAILURE = "ADD_REJECT_REQUEST_FAILURE";
export const ADD_PAY_REQUEST_REQUEST = "ADD_PAY_REQUEST_REQUEST";
export const ADD_PAY_REQUEST_SUCCESS = "ADD_PAY_REQUEST_SUCCESS";
export const ADD_PAY_REQUEST_FAILURE = "ADD_PAY_REQUEST_FAILURE";
export const ADD_QUERY_REQUEST_REQUEST = "ADD_QUERY_REQUEST_REQUEST";
export const ADD_QUERY_REQUEST_SUCCESS = "ADD_QUERY_REQUEST_SUCCESS";
export const ADD_QUERY_REQUEST_FAILURE = "ADD_QUERY_REQUEST_FAILURE";
export const FETCH_EXECUTIVE_VOUCHERS_REQUEST =
  "FETCH_EXECUTIVE_VOUCHERS_REQUEST";
export const FETCH_EXECUTIVE_VOUCHERS_SUCCESS =
  "FETCH_EXECUTIVE_VOUCHERS_SUCCESS";
export const FETCH_EXECUTIVE_VOUCHERS_FAILURE =
  "FETCH_EXECUTIVE_VOUCHERS_FAILURE";
export const CLEAR_EXECUTIVE_REQUESTS_ERROR = "CLEAR_EXECUTIVE_REQUESTS_ERROR";
